"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultBebopPagination = void 0;
const mobx_1 = require("mobx");
const find_page_on_limit_change_1 = require("@App/helpers/pagination/find-page-on-limit-change");
const search_1 = require("@App/api/routes/search");
const calc_num_pages_1 = require("@App/helpers/pagination/calc-num-pages");
const registration_status_1 = require("@App/enum/registration-status");
exports.defaultBebopPagination = {
    page: 1,
    limit: 10,
};
class RegistrationHistoryTabStore {
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_lastQueryOnTab", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_works", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_pagination", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_paginationInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this, {
            _lastQueryOnTab: mobx_1.observable,
            _works: mobx_1.observable,
            _pagination: mobx_1.observable,
            _paginationInfo: mobx_1.observable,
            setCurrentPage: mobx_1.action,
            setLimit: mobx_1.action,
            resetStore: mobx_1.action,
        });
        this.rootStore = rootStore;
        this._lastQueryOnTab = {};
        this._pagination = exports.defaultBebopPagination;
    }
    get lastQueryOnTab() {
        return this._lastQueryOnTab;
    }
    get works() {
        return this._works;
    }
    get pagination() {
        return this._pagination;
    }
    get paginationInfo() {
        return this._paginationInfo;
    }
    get limit() {
        var _a;
        return (_a = this._pagination.limit) !== null && _a !== void 0 ? _a : 10;
    }
    setCurrentPage(page) {
        this._pagination.page = page;
    }
    setLimit(num) {
        if (this._works) {
            const newPage = (0, find_page_on_limit_change_1.findPageOnLimitChange)(this._pagination, this._works.count, num, 1);
            this.setCurrentPage(newPage);
        }
        this._pagination.limit = num;
    }
    resetStore() {
        this._lastQueryOnTab = {};
        this._works = undefined;
        this._pagination = exports.defaultBebopPagination;
        this._paginationInfo = undefined;
    }
    searchRegistrationHistory(registrationStatusAndFilters_1) {
        return __awaiter(this, arguments, void 0, function* (registrationStatusAndFilters, pagination = { page: 1, limit: 10 }, filters) {
            const rightsholderId = this.rootStore.rightsholderStore.currentRightsholderId;
            let statusFilters = [];
            let sourceFilters = [];
            let sortByString;
            if (registrationStatusAndFilters.status === registration_status_1.RegistrationStatus.processing) {
                sortByString = (filters === null || filters === void 0 ? void 0 : filters.sort_by) ? filters.sort_by : 'submission_date';
                statusFilters = this.getStatusFilterArray(filters);
                if (statusFilters.length === 0) {
                    statusFilters = registrationStatusAndFilters.defaultFilters;
                }
                sourceFilters = this.getSourceFilterArray(filters);
            }
            try {
                const axiosResponse = yield (0, search_1.searchWorksHistoryRH)(rightsholderId, pagination, registrationStatusAndFilters.status, this.rootStore.registrationHistoryStore.currentQuery, statusFilters, sourceFilters, this.rootStore.registrationHistoryStore.isCriteriaPresent() ? undefined : sortByString);
                const response = axiosResponse.data;
                (0, mobx_1.runInAction)(() => {
                    this._works = {
                        works: response.data,
                        count: response.count,
                    };
                    this._lastQueryOnTab = this.rootStore.registrationHistoryStore.currentQuery;
                });
                if (pagination.limit && response && pagination.page) {
                    this.setLimit(pagination.limit);
                    this.setCurrentPage(pagination.page);
                    this._paginationInfo = (0, calc_num_pages_1.calcNumPages)(response.count, pagination.limit, pagination.page);
                }
                this.rootStore.workStore.destroyViewWork();
            }
            catch (e) {
                this.rootStore.popupStore.setAlertFromError(e);
            }
        });
    }
    getStatusFilterArray(filters) {
        const filtersArray = [];
        if (filters) {
            if (filters.accepted) {
                filtersArray.push('accepted');
            }
            if (filters.rejected) {
                filtersArray.push('rejected');
            }
            if (filters.processing) {
                filtersArray.push('processing');
            }
            if (filters.superseded) {
                filtersArray.push('superseded');
            }
        }
        return filtersArray;
    }
    getSourceFilterArray(filters) {
        const filtersArray = [];
        if (filters) {
            if (filters.cwr) {
                filtersArray.push('cwr');
            }
            if (filters.esong) {
                filtersArray.push('esong');
            }
            if (filters.mlc) {
                filtersArray.push('mlc');
            }
        }
        return filtersArray;
    }
}
exports.default = RegistrationHistoryTabStore;
